import type { SlideShowItem } from '@/models/types/application/slide-show-item'
import { makeRequest, type MakeRequestOptions } from './make-request'

type ApplicationCrudType = () => {
    getSlides: (options?: MakeRequestOptions) => Promise<SlideShowItem[]>
}

const APPLICATION_URL =
    typeof window === 'undefined'
        ? `${process.env.API_URL}/api/v1/Applicazione/SlidesShow`
        : `${location.origin}${process.env.NEXT_PUBLIC_BASEPATH}/api/v1/Applicazione/SlidesShow`
const APPLICATION_TAG = 'Application'
const SLIDES_TAG = 'Slides'

const applicationCrud: ApplicationCrudType = () => ({
    getSlides: async (options) => {
        const url = new URL(APPLICATION_URL)
        const slides = await makeRequest<SlideShowItem[]>(url, {
            method: 'GET',
            next: { tags: [APPLICATION_TAG, SLIDES_TAG] },
            ...options,
        })
        return slides
    },
})

export { APPLICATION_TAG, applicationCrud, SLIDES_TAG, type ApplicationCrudType }
